import i18n from "@breward/i18n";

export const DRINK_TYPES = {
  beer: i18n.t("global:shared.DrinkType.Beer", "Beer"),
  mead: i18n.t("global:shared.DrinkType.Mead", "Mead"),
  cider: i18n.t("global:shared.DrinkType.Cider", "Cider"),
  wine: i18n.t("global:shared.DrinkType.Wine", "Wine"),
};

export const STYLE_STATES = {
  draft: {
    label: i18n.t("global:shared.StyleState.Draft", "Draft"),
    color: "disabled",
  },
  waiting_for_approval: {
    label: i18n.t(
      "global:shared.StyleState.WaitingForApproval",
      "Waiting for approval"
    ),
    color: "warning",
  },
  approved: {
    label: i18n.t("global:shared.StyleState.Approved", "Approved"),
    color: "info",
  },
  published: {
    label: i18n.t("global:shared.StyleState.Published", "Published"),
    color: "success",
  },
};
